export type InteractableObjectManifestJson = {
    id: string
    label: string
    inspect?: {
        text: string
        srcURL: string
    }
    interact?: {
        text: string
        srcURL: string
        action?: string
    }
}

export type TakeableObjectManifestJson = InteractableObjectManifestJson & {
    inventoryItemID: string
    overlayImage: string
}

export enum WaypointType {
    gameScene = 'gameScene',
    level = 'level',
}

export type WaypointManifestJson = InteractableObjectManifestJson & {
    type: WaypointType
    locked: boolean
    interactLocked?: {
        text: string
        srcURL: string
    }
    inspectLocked?: {
        text: string
        srcURL: string
    }
}
